import React from 'react';
import PropTypes from 'prop-types';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';

import { errorImage } from '../assets/images/images';
import { changeNavigation } from '../redux/head/headActions';


class ErrorPage extends React.Component {
	componentDidMount() {
		this.props.changeNavigation();
	}

	render() {
		return (
			<div className="layout-error-page">
				<img
					src={errorImage}
					className="error-page--image"
					alt=""
				/>
				<h3 className="error-page--description">
					<FormattedMessage id="ERROR_404.DESCRIPTION" defaultMessage="" />
				</h3>
				<Link to="/" href="/" className="a-button--ghost error-page--link">
					<FormattedMessage id="ERROR_404.LINK_TEXT" defaultMessage="" />
				</Link>
			</div>
		);
	}
}

ErrorPage.propTypes = {
	changeNavigation: PropTypes.func.isRequired,
};

export default withRouter(connect(null, {
	changeNavigation,
})(ErrorPage));



// WEBPACK FOOTER //
// ./src/pages/error.page.js